// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"style_tooltipContainer__3Hoab","explanation":"style_explanation__8Bm2e"};